// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"297":"bd3507b5","385":"bd3507b5","421":"902393c7"}[chunkId] + ".chunk.css";
};